<template>
  <div class="inspection-result">
    <div
        class="character-card"
        v-for="(character, index) in characters"
        :key="character.id"
    >
      <!-- Character Info -->
      <div class="character-info">
        <div class="character-name">{{ character.name || "xx" }}</div>
        <div class="rank">
          Rank: <span class="rank-value">{{ character.rank_grade || "xx" }}</span>
        </div>
      </div>

      <!-- Attributes -->
      <div class="character-attributes">
        <div
            class="attribute"
            v-for="(attribute, index) in character.attributes || []"
            :key="index"
        >
          <span class="attribute-name">
            {{ attribute.name || "xx" }}:
          </span>
          <span class="attribute-value">
            {{ attribute.current !== undefined ? attribute.current : "xx" }}
            /
            {{ attribute.max !== undefined ? attribute.max : "xx" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InspectionResult",
  props: {
    characters: {
      type: Array,
      required: true, // Array of inspection results
    },
  },
};
</script>

<style scoped>
/* Container for the inspection results */
.inspection-result {
  display: flex;
  flex-wrap: wrap;
  gap: 1em; /* Space between cards */
  justify-content: flex-start;
}

/* Individual character card */
.character-card {
  display: flex;
  flex-direction: column;
  background-color: var(--gm-surface-2);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius-sm);
  padding: 1em;
  width: 14em;
  box-sizing: border-box;
  text-align: left;
  color: var(--gm-text);
  font-size: 0.9em;
}

.character-name {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 0.5em;
  color: var(--gm-accent);
}

.rank {
  font-size: 0.9em;
  color: var(--gm-text-muted);
  margin-bottom: 0.5em;
}

.rank-value {
  font-weight: bold;
  color: var(--gm-text);
}

.character-attributes {
  display: flex;
  flex-direction: column;
  gap: 0.3em;
}

.attribute {
  display: flex;
  justify-content: space-between;
  font-size: 0.85em;
}

.attribute-name {
  color: var(--gm-text-muted);
}

.attribute-value {
  color: var(--gm-text);
  font-weight: bold;
}
</style>
